import { variant } from 'styled-system'

const sizeVariant = variant({
  prop: 'size',
  variants: {
    small: {
      fontSize: '12px',
      lineHeight: '20px',
      padding: '6px 12px',
    },
    default: {
      fontSize: '14px',
      lineHeight: '24px',
      padding: '8px 12px',
    },
  },
})

export { sizeVariant }
